import { render, staticRenderFns } from "./FifthTable.vue?vue&type=template&id=b05571da&"
import script from "./FifthTable.vue?vue&type=script&lang=js&"
export * from "./FifthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports